import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import {
  CONTACT_PHONE,
  CONTACT_PHONE_HREF,
  CONTACT_EMAIL,
  CONTACT_EMAIL_HREF,
} from "@/components/Nav";

// Sticky contact bar fixed to the bottom of the viewport on every device.
// Two large tap-friendly action buttons: Call + Email.
export default function StickyContactBar() {
  return (
    <motion.div
      data-testid="sticky-contact-bar"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.6, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#050505]/95 backdrop-blur-xl border-t border-[#1e1e1e]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="mx-auto max-w-[1600px] px-3 sm:px-4 md:px-6 grid grid-cols-2 gap-2 sm:gap-3 md:gap-4 py-2 sm:py-3">
        <a
          href={CONTACT_PHONE_HREF}
          data-testid="sticky-phone"
          className="group inline-flex items-center justify-center gap-2 md:gap-3 border border-[#FF3B30] bg-[#FF3B30] hover:bg-[#050505] hover:text-[#FF3B30] text-[#050505] py-3 md:py-4 px-3 md:px-6 font-display uppercase tracking-[0.12em] md:tracking-[0.16em] text-[11px] sm:text-xs md:text-sm transition-colors"
        >
          <Phone size={14} strokeWidth={2.5} className="flex-shrink-0" />
          <span className="truncate">
            <span className="hidden sm:inline">Call </span>
            {CONTACT_PHONE}
          </span>
        </a>
        <a
          href={CONTACT_EMAIL_HREF}
          data-testid="sticky-email"
          className="group inline-flex items-center justify-center gap-2 md:gap-3 border border-white/25 hover:border-[#FF3B30] hover:text-[#FF3B30] text-white py-3 md:py-4 px-3 md:px-6 font-display uppercase tracking-[0.12em] md:tracking-[0.16em] text-[11px] sm:text-xs md:text-sm transition-colors"
        >
          <Mail size={14} strokeWidth={2.5} className="flex-shrink-0" />
          <span className="truncate">
            <span className="hidden sm:inline">Email </span>
            <span className="sm:hidden">Email</span>
            <span className="hidden sm:inline">{CONTACT_EMAIL}</span>
          </span>
        </a>
      </div>
    </motion.div>
  );
}
